import { render, staticRenderFns } from "./IntegrationDetail.vue?vue&type=template&id=ffceff9c&scoped=true&"
import script from "./IntegrationDetail.vue?vue&type=script&lang=js&"
export * from "./IntegrationDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationDetail.vue?vue&type=style&index=0&id=ffceff9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffceff9c",
  null
  
)

export default component.exports